import { sessionService } from "redux-react-session";
import { LOGGED_IN } from "../constants";

export const logout = () => {
  localStorage.setItem(LOGGED_IN, JSON.stringify(0));
  sessionService.deleteSession();
  sessionService.deleteUser();
};
